/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Media Plans API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
/**
 *
 * @export
 * @interface ScenarioAdFormatResponseDto
 */
export interface ScenarioAdFormatResponseDto {
    /**
     *
     * @type {string}
     * @memberof ScenarioAdFormatResponseDto
     */
    adFormatCode?: string | null;
    /**
     *
     * @type {string}
     * @memberof ScenarioAdFormatResponseDto
     */
    adFormatName?: string | null;
    /**
     *
     * @type {number}
     * @memberof ScenarioAdFormatResponseDto
     */
    cpm?: number | null;
    /**
     *
     * @type {boolean}
     * @memberof ScenarioAdFormatResponseDto
     */
    isChecked?: boolean | null;
    /**
     *
     * @type {number}
     * @memberof ScenarioAdFormatResponseDto
     */
    budget?: number | null;
}

/**
 * Check if a given object implements the ScenarioAdFormatResponseDto interface.
 */
export function instanceOfScenarioAdFormatResponseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ScenarioAdFormatResponseDtoFromJSON(json: any): ScenarioAdFormatResponseDto {
    return ScenarioAdFormatResponseDtoFromJSONTyped(json, false);
}

export function ScenarioAdFormatResponseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ScenarioAdFormatResponseDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        adFormatCode: !exists(json, 'ad_format_code') ? undefined : json['ad_format_code'],
        adFormatName: !exists(json, 'ad_format_name') ? undefined : json['ad_format_name'],
        cpm: !exists(json, 'cpm') ? undefined : json['cpm'],
        isChecked: !exists(json, 'is_checked') ? undefined : json['is_checked'],
        budget: !exists(json, 'budget') ? undefined : json['budget'],
    };
}

export function ScenarioAdFormatResponseDtoToJSON(value?: ScenarioAdFormatResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ad_format_code: value.adFormatCode,
        ad_format_name: value.adFormatName,
        cpm: value.cpm,
        is_checked: value.isChecked,
        budget: value.budget,
    };
}
